import React, { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { navigation } from '../../app-navigation';
import './overview.scss';

export const OverviewPage = ({ sectionPath }: { sectionPath?: string }) => {
  const [search, setSearch] = useState('');
  const currentSection = navigation.find(section => section.path === sectionPath);

  const sections = useMemo(() => {
    const query = search.trim().toLocaleLowerCase();
    return navigation
      .filter(section => section.items.length > 0 && (!sectionPath || section.path === sectionPath))
      .map(section => ({
        ...section,
        items: section.items.filter(item => !query || `${section.text} ${item.text}`.toLocaleLowerCase().includes(query)),
      }))
      .filter(section => section.items.length > 0);
  }, [search, sectionPath]);

  const itemCount = sections.reduce((total, section) => total + section.items.length, 0);

  return (
    <main className='overview-page'>
      <div className='overview-heading'>
        <h1>{currentSection?.text || 'Tổng quan'}</h1>
        <p>{sectionPath === '/planning' ? 'Tổ chức công việc và chủ động kế hoạch mỗi ngày.' : sectionPath === '/analytics' ? 'Theo dõi số liệu và nắm bắt tình hình hoạt động.' : 'Kết nối công việc. Truy cập nhanh các chức năng bạn cần.'}</p>
      </div>

      <label className='overview-search'>
        <input
          type='search'
          value={search}
          onChange={event => setSearch(event.target.value)}
          placeholder='Tìm chức năng'
          aria-label='Tìm chức năng'
        />
        <span className='dx-icon dx-icon-search' aria-hidden='true' />
      </label>

      {sections.length ? sections.map(section => (
        <section className='overview-section' key={section.text}>
          <div className='overview-section-heading'>
            <h2>{section.text}</h2>
            <span>{section.items.length}</span>
          </div>
          <div className='overview-grid'>
            {section.items.map(item => (
              <Link className='overview-card' to={item.path} key={item.path}>
                <div className='overview-card-title'>{item.text}</div>
                <div className='overview-card-preview'>
                  <span className={`dx-icon dx-icon-${item.icon}`} aria-hidden='true' />
                  <span className='overview-card-open'>Mở chức năng <span aria-hidden='true'>→</span></span>
                </div>
              </Link>
            ))}
          </div>
        </section>
      )) : (
        <div className='overview-empty'>Không tìm thấy chức năng phù hợp.</div>
      )}
      <span className='overview-result-count' aria-live='polite'>{itemCount} chức năng</span>
    </main>
  );
};

export const AnalyticsCatalogPage = () => <OverviewPage sectionPath='/analytics' />;
export const PlanningCatalogPage = () => <OverviewPage sectionPath='/planning' />;
